module.exports = __webpack_public_path__ + "img/E2D3BC_867255_B39E7F_96836C-256px.9de573e1.png";